const planneds = {};

export const setThrottledTimout = (f, delay, key) => {
  const now = Date.now();
  if (planneds[key] && now - planneds[key].at < delay) {
    clearTimeout(planneds[key].timeoutID);
  }
  planneds[key] = {
    timeoutID: setTimeout(f, delay),
    at: now,
  };
};
